import { defineAction } from 'rd-redux-utils';

export const cancelSagasAction = defineAction('CANCEL SAGAS');
